import { useMemo } from 'react';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import { svgSprite } from '../../../hybrid/wrappers';
import css from './InfoMarker.module.scss';
import { t } from '../../../common/components/T';

const InfoMarker = ({ contactData, setShowModal, translates }) => {
    const isMobile = useWindowDimensions() < 768;

    const socialWeb = useMemo(() => {
        if (!contactData) return;
        const socialPosition = [];

        const socialInit = ['facebook', 'instagram', 'twitter', 'vk', 'ok', 'tiktok', 'clubhouse'];
        const keysSocial = Object.keys(contactData);

        keysSocial.forEach((el) =>
            socialInit.includes(el) && !!contactData[el] ? socialPosition.push({ title: el, value: contactData[el] }) : null
        );

        return socialPosition;
    }, [contactData]);

    const messengeres = (val) => {
        if (!contactData) return;
        const filteredMessenger = [];

        const messengerInit = ['telegram', 'viber', 'whatsapp'];
        contactData.contacts.forEach((el) =>
            messengerInit.includes(el.type) && el.value === val
                ? filteredMessenger.push({ title: el.type, value: el.value })
                : null
        );

        return filteredMessenger;
    };

    const contacts = () => {
        if (!contactData) return;
        const filteredContact = [];

        const contactInit = ['email', 'tel', 'skype'];

        contactData?.contacts?.forEach((el) => (contactInit?.includes(el.type) && !!el.value ? filteredContact.push(el) : null));

        return filteredContact;
    };

    return (
        <>
            <div>
                <p className={css.containerTitle}>{contactData?.name}</p>
                <p className={css.infoType}>{contactData?.type?.title}</p>
            </div>
            {isMobile && (
                <div onClick={() => setShowModal(false)} className={css.closeIcon}>
                    {svgSprite('CloseModal', {
                        width: 10,
                        height: 10,
                        fill: 'var(--greySuperDarkColor)'
                    })}
                </div>
            )}
            <div style={{ width: '100%' }}>
                {contacts()?.map((elem, idx) => {
                    const { type, value, description } = elem;
                    const contact = type === 'tel' ? `tel:${value}` : type === 'email' ? `mailto:${value}` : `skype:${value}`;
                    return (
                        <>
                            <div className={css.contactBlock}>
                                <div className={css.contactSvg}>
                                    {svgSprite(type === 'email' ? 'envelope' : type === 'tel' ? 'phone' : 'skype', {
                                        width: '24px',
                                        height: '24px',
                                        fill: 'var(--greyExtraDarkColor)'
                                    })}
                                </div>
                                <div className={css.BlockContainer}>
                                    <p className={css.blockfirstText}>
                                        <a
                                            style={{
                                                color: 'var(--blueColor)',
                                                outline: 'none',
                                                border: 'none',
                                                boxShadow: 'none'
                                            }}
                                            href={contact}
                                        >
                                            {value}
                                        </a>
                                    </p>
                                    <p className={css.blockSecondText}>{description}</p>
                                </div>
                                {type === 'tel' && (
                                    <div style={{ display: 'flex' }}>
                                        {messengeres(value)?.map((el) => {
                                            switch (el.title) {
                                                case 'telegram':
                                                    return (
                                                        <a
                                                            className={css.iconMargin}
                                                            href={`http://t.me/${el.value}`}
                                                            target='_blank'
                                                            rel='noreferrer'
                                                        >
                                                            {svgSprite('telegram-colored', {
                                                                width: '24px',
                                                                height: '24px',
                                                                fill: 'var(--blueSkyHalfTransparentColor)'
                                                            })}
                                                        </a>
                                                    );
                                                case 'viber':
                                                    return (
                                                        <a
                                                            className={css.iconMargin}
                                                            href={`viber://add?number=${el.value}`}
                                                            target='_blank'
                                                            rel='noreferrer'
                                                        >
                                                            {svgSprite('viber-colored', {
                                                                width: '24px',
                                                                height: '24px',
                                                                fill: 'var(--bluePurpleColor)'
                                                            })}
                                                        </a>
                                                    );
                                                case 'whatsapp':
                                                    return (
                                                        <a
                                                            className={css.iconMargin}
                                                            href={`https://wa.me/${el.value}`}
                                                            target='_blank'
                                                            rel='noreferrer'
                                                        >
                                                            {svgSprite('whatsapp-colored', {
                                                                width: '24px',
                                                                height: '24px',
                                                                fill: 'var(--greenDeepDarkColor)'
                                                            })}
                                                        </a>
                                                    );
                                            }
                                        })}
                                    </div>
                                )}
                            </div>

                            {contacts()[idx + 1] || contactData?.custom_contacts?.length ? (
                                <div className={css.borderLine}></div>
                            ) : null}
                        </>
                    );
                })}

                {!!contactData?.custom_contacts?.length && (
                    <>
                        {contactData.custom_contacts.map((item, idx) => (
                            <>
                                <div className={css.contactBlock}>
                                    <div>
                                        {svgSprite('pin', {
                                            width: '24px',
                                            height: '24px',
                                            fill: 'var(--greyExtraDarkColor)'
                                        })}
                                    </div>
                                    <div className={css.BlockContainer}>
                                        <p className={css.blockfirstAdrres}>{item.value}</p>
                                        <p className={css.blockSecondText}>{item.description}</p>
                                    </div>
                                </div>

                                {contactData.custom_contacts[idx + 1] || socialWeb?.length ? (
                                    <div className={css.borderLine}></div>
                                ) : null}
                            </>
                        ))}
                    </>
                )}
            </div>

            {socialWeb?.length ? (
                <div>
                    <p className={css.socialTitle}>{t('socialTitle', 'Мы в соц. сетях', 'widget', translates, 'map')}</p>
                    <div style={{ display: 'flex' }}>
                        {socialWeb?.map((el) => {
                            switch (el.title) {
                                case 'facebook':
                                    return (
                                        <a
                                            className={css.iconMargin}
                                            href={`https://facebook.com/${el.value}`}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            {svgSprite('facebook-colored', {
                                                width: '24px',
                                                height: '24px',
                                                fill: 'var(--blueDeepAddColor)'
                                            })}
                                        </a>
                                    );
                                case 'twitter':
                                    return (
                                        <a
                                            href={`https://twitter.com/${el.value}`}
                                            target='_blank'
                                            className={css.iconMargin}
                                            rel='noreferrer'
                                        >
                                            {svgSprite('twitter-colored', {
                                                width: '24px',
                                                height: '24px',
                                                fill: 'var(--blueDeepAddColor)'
                                            })}
                                        </a>
                                    );
                                case 'instagram':
                                    return (
                                        <a
                                            className={css.iconMargin}
                                            href={`https://www.instagram.com/${el.value}`}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            {svgSprite('instagram-colored', {
                                                width: '24px',
                                                height: '24px'
                                            })}
                                        </a>
                                    );
                                case 'clubhouse':
                                    return (
                                        <a
                                            className={css.iconMargin}
                                            href={`https://www.joinclubhouse.com/${el.value}`}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            {svgSprite('clubhouse-colored', {
                                                width: '24px',
                                                height: '24px'
                                            })}
                                        </a>
                                    );
                                case 'tiktok':
                                    return (
                                        <a
                                            className={css.iconMargin}
                                            href={`https://www.tiktok.com/${el.value}`}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            {svgSprite('tiktok-colored', {
                                                width: '24px',
                                                height: '24px'
                                            })}
                                        </a>
                                    );
                                case 'vk':
                                    return (
                                        <a
                                            className={css.iconMargin}
                                            href={`https://vk.com/${el.value}`}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            {svgSprite('vkontakte-colored', {
                                                width: '24px',
                                                height: '24px'
                                            })}
                                        </a>
                                    );
                                case 'ok':
                                    return (
                                        <a
                                            className={css.iconMargin}
                                            href={`https://ok.ru/${el.value}`}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            {svgSprite('odnoklassniki-colored', {
                                                width: '24px',
                                                height: '24px'
                                            })}
                                        </a>
                                    );
                            }
                        })}
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default InfoMarker;
